export default {
  baseURL: '',
  // baseURL: 'http://192.168.8.50:12022',
  // baseURL: 'http://evaluation.vaneqi.com'
}